import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use"

// Connects to data-controller="sidebar"
export default class extends Controller {
  connect() {
    useClickOutside(this)
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundHandleKeydown)
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundHandleKeydown)
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  open() {
    const sidebar = document.getElementById('sidebar')
    if (sidebar) {
      sidebar.classList.remove('hidden')

      const panelElement = document.getElementById("sidebar-panel")
      const backdropElement = document.getElementById("sidebar-backdrop")

      if (panelElement && backdropElement) {
        panelElement.classList.add('-translate-x-full')
        setTimeout(() => {
          panelElement.classList.remove('-translate-x-full')
          panelElement.classList.add('translate-x-0')
          backdropElement.classList.remove('opacity-0')
          backdropElement.classList.add('opacity-100')
        }, 10)
      }
    }

    const sidebar_close = document.getElementById('sidebar-close')
    if (sidebar_close) {
      sidebar_close.classList.remove('hidden')
      document.activeElement.blur()
    }
  }

  close() {
    const sidebar = document.getElementById('sidebar')
    if (sidebar) {
      const panelElement = document.getElementById("sidebar-panel")
      const backdropElement = document.getElementById("sidebar-backdrop")

      if (panelElement && backdropElement) {
        panelElement.classList.remove('translate-x-0')
        panelElement.classList.add('-translate-x-full')
        backdropElement.classList.remove('opacity-100')
        backdropElement.classList.add('opacity-0')
        setTimeout(() => {
          sidebar.classList.add('hidden')
        }, 300)
      }
    }

    const sidebar_close = document.getElementById('sidebar-close')
    if (sidebar_close) {
      sidebar_close.classList.add('hidden')
    }
  }
}
